import { Component, OnInit } from '@angular/core';
import { setTimeout$ } from 'src/app/core/common';
import { InsightsService } from 'src/app/services/insights.service';
import { SharedService } from 'src/app/services/shared.service';

declare const FB: any;
@Component({
  selector: 'app-insights',
  templateUrl: './insights.component.html',
  styleUrls: ['./insights.component.scss']
})
export class InsightsComponent implements OnInit {
  _display: any = {};
  settings: string;
  updateIgPagesResponse: any;
  authResponse: any;
  meResponse: any;
  apiUrl: string;
  apiResponse: any;

  scope = 'public_profile,email';
  exchangeResponse: any;
  debugAccessToken: string;
  debugTokenResponse: any;
  igPage: string = 'karpisheh';
  dumpResponse: any;
  insightsResponse: any;

  constructor(private sharedService: SharedService, private insightsService: InsightsService) { }

  async ngOnInit() {
    this.sharedService.addScript({ code: `window.fbAsyncInit=function(){FB.init({appId: '${this.insightsService.FB_AppID}',autoLogAppEvents : true,xfbml: true,version: 'v14.0'});};` });
    this.sharedService.addScript({ async: true, defer: true, crossOrigin: 'anonymous', src: 'https://connect.facebook.net/en_US/sdk.js' });

    setTimeout$(() => {
      if (typeof (FB) != 'undefined')
        FB.getLoginStatus(async res => await this.statusChangeCallback(res));
    }, 1000);

    this.settings = JSON.stringify(await this.insightsService.getSettings(), null, 2);
  }
  async statusChangeCallback(res: any) {
    console.log(res);
    FB.api('/me', function (response) {
      this.meResponse = response;
    });

    this.authResponse = res;
  }

  connect() {
    FB.login(async res => await this.statusChangeCallback(res), { scope: this.scope });
  }

  async getLongAccessTokens() {
    const accessToken = this.authResponse.authResponse?.accessToken;
    const userId = this.authResponse.authResponse?.userID;
    this.exchangeResponse = await this.insightsService.exchangeToken(accessToken, userId);
  }

  async apiRequest() {
    this.apiResponse = await this.insightsService.apiRequest(this.apiUrl);
  }
  async debugToken() {
    this.debugTokenResponse = await this.insightsService.debugToken(this.debugAccessToken);
  }
  async dump() {
    this.dumpResponse = await this.insightsService.dumpIgPage(this.igPage);
  }
  async getInsights() {
    this.insightsResponse = await this.insightsService.getIgPageInsights();
  }
  async updateIgPages() {
    this.updateIgPagesResponse = await this.insightsService.updateIgPages();
  }
  async saveSettings() {
    this.settings = JSON.stringify(await this.insightsService.saveSettings(JSON.parse(this.settings)), null, 2);
  }



}
